import './StepsCounter.scss'

import { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Card } from 'react-bootstrap'

import confetti from 'canvas-confetti'

import { getAuthenticatedUser } from 'components/auth'
import CourseContext from 'components/common/contexts/CourseContext'
import {
  ROUTE_ASSESSMENT_PROGRAM,
  ROUTE_CHAT_GENERAL
} from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { getAllCourseProgress } from 'components/common/api/CourseProgress'

import RembleAvatar from '../../../assets/images/Remble_Logomark-Green-25pGreen.png'

const getCongratsMessage = (steps, username) => {
  const nameWithComma = username ? ', ' + username : ''

  if (steps < 5) return ` You're doing great${nameWithComma}!`
  if (steps < 10) return ` That's excellent${nameWithComma}!`
  if (steps < 20) return ` Nice work${nameWithComma}! 🎉`
  if (steps < 30) return ` Keep it up${nameWithComma}! 🎉`

  return ` That's amazing${nameWithComma}! 🎉`
}

/**
 * Steps Counter component. Used for displaying the steps counter.
 */
export default function StepsCounter({ userPreferences }) {
  const history = useHistory()
  const user = getAuthenticatedUser()
  const { setProgress } = useContext(CourseContext)
  const [steps, setSteps] = useState(0)
  const [userProgress, setUserProgress] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  // Set up our confetti animation
  const count = 200
  const defaults = {
    origin: { y: 0.3, x: 0.2 }
  }

  const fireConfetti = (particleRatio, opts) => {
    // Create our confetti
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio)
      })
    )
  }

  useEffect(() => {
    // Return if we've updated the progress already or if we don't have a way to set the progress
    if (!setProgress || userProgress.length) return

    // Get the user's progress
    async function getUserProgressAsync() {
      const progress = await getAllCourseProgress()

      // Get total steps count from progress and set it
      const totalSteps = progress.reduce((acc, curr) => {
        return acc + curr.steps_completed
      }, 0)

      // Set the progress
      setProgress(progress)
      setUserProgress(progress)

      // Update our steps
      setSteps(totalSteps)

      // Update our loading state
      setIsLoading(false)
    }

    getUserProgressAsync()
  }, [userProgress.length, setProgress])

  return (
    <div className='steps-completed-banner mb-4'>
      <Card className='mb-5'>
        <Card.Body>
          <Card.Title>
            <span className='icon'>
              <i className='bi bi-gem' />
            </span>
            Sessions <strong>{steps}</strong>
          </Card.Title>
          <Card.Text>
            {/* If we're still loading, let the user know */}
            {isLoading ? (
              <span className='muted'>Counting your sessions...</span>
            ) : (
              <>
                {steps > 2 && (
                  <span
                    className='green'
                    onClick={() => {
                      // Only fire confetti if we've completed at least 15 steps
                      if (steps >= 15) {
                        // Fire confetti :)
                        fireConfetti(0.1, {
                          spread: 120,
                          startVelocity: 25,
                          decay: 0.92,
                          scalar: 1.2
                        })
                      }
                    }}
                  >
                    <img
                      src={RembleAvatar}
                      alt=''
                      width='30'
                      style={{ position: 'relative', top: '-4px' }}
                    />{' '}
                    {getCongratsMessage(steps, user?.display_name)}
                  </span>
                )}

                <span
                  className='muted mt-2 d-block'
                  onClick={_ =>
                    navigateTo(
                      `${ROUTE_CHAT_GENERAL}/change-partner?returnPath=${ROUTE_ASSESSMENT_PROGRAM}`,
                      history
                    )
                  }
                >
                  I’m here to offer support as your personal change partner.
                  <br />
                  <br />{' '}
                  <span className='green'>
                    See how I can help you <i className='bi bi-arrow-right' />
                  </span>
                </span>
              </>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  )
}
